import {Component, OnInit} from '@angular/core';
import {DataService} from '../../services/data.service';
import {HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {UtilsService} from '../../services/utils.service';

@Component({
    selector: 'app-test',
    templateUrl: './test.component.html',
    styleUrls: ['./test.component.css']
})
export class TestComponent implements OnInit {
    method: string = 'GET';
    url: string = '';
    body: string = '';
    response: string = '';

    constructor(private dataService: DataService,
                private utilsService: UtilsService
    ) {
    }

    ngOnInit() {
    }

    test($event) {
        if (this.url !== '') {
            switch (this.method) {
                case 'GET':
                    this.dataService.get(this.url, this.getHeader()).subscribe((response) => {
                        this.response = JSON.stringify(response, null, 2);
                    }, (error) => {
                        if (error instanceof HttpErrorResponse) {
                            this.response = error.message;
                        }
                    });
                    break;
                case 'POST':
                    try {
                        const body: any = JSON.parse(this.body);
                        this.dataService.post(this.url, body, this.getHeader()).subscribe((response) => {
                            this.response = JSON.stringify(response, null, 2);
                        }, (error) => {
                            if (error instanceof HttpErrorResponse) {
                                this.response = error.message;
                            }
                        });
                    } catch (error) {
                        if (error instanceof HttpErrorResponse) {
                            this.response = error.message;
                        }
                    }
                    break;
            }
        }
    }

    private getHeader(): HttpHeaders {
        let headers = new HttpHeaders();
        const programId = sessionStorage.getItem('currentProgram');
        this.utilsService.debugLog(programId);
        if (programId) {
            headers = headers.set('Program', programId);
        }

        return headers;
    }

}



// WEBPACK FOOTER //
// ./src/app/core/components/test/test.component.ts